import { useEffect, useState, useContext } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { UserContext } from '../../contexts/user.context';
import './effectlogin.css'; // Import the CSS file containing keyframes
import {  ChatBubbleLeftRightIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline'
import Footer from '../../components/footer';

const customerReviews = [
  {
    name: 'Maria Santos',
    role: 'Owner, MJS Sari-Sari Store',
    rating: 5,
    quote: 'Pentabooks helped me track daily sales and supplier expenses without needing a full-time accountant.',
  },
  {
    name: 'Kevin dela Cruz',
    role: 'Operations Manager, KDC Hardware',
    rating: 5,
    quote: 'The reports are easy to review before month-end. Our team now closes records much faster than before.',
  },
  {
    name: 'Angela Reyes',
    role: 'Founder, AR Online Boutique',
    rating: 5,
    quote: 'I like that the dashboard is simple enough for a small business owner but still detailed when I need it.',
  },
  {
    name: 'Jonas Lim',
    role: 'Partner, JL Cafe and Kitchen',
    rating: 4,
    quote: 'We use it to monitor receipts, expenses, and tax documents in one place. It saves us a lot of follow-up work.',
  },
  {
    name: 'Patricia Gomez',
    role: 'Admin Head, Gomez Dental Clinic',
    rating: 5,
    quote: 'Uploading business documents and checking entries became much more organized for our clinic staff.',
  },
  {
    name: 'Mark Villanueva',
    role: 'Owner, MV Auto Supply',
    rating: 5,
    quote: 'What I appreciate most is the cleaner bookkeeping workflow. It reduced manual spreadsheet work for us.',
  },
  {
    name: 'Sofia Navarro',
    role: 'Finance Assistant, Navarro Pharmacy',
    rating: 4,
    quote: 'The sales and expense summaries are practical for weekly reviews, especially when preparing for tax filing.',
  },
  {
    name: 'Carlo Mendoza',
    role: 'Co-owner, CM Printing Services',
    rating: 5,
    quote: 'Pentabooks feels built for real SMEs. The interface is straightforward and our bookkeeper learned it quickly.',
  },
  {
    name: 'Janine Lopez',
    role: 'Owner, JL Beauty Studio',
    rating: 5,
    quote: 'I can finally see where the money goes each month without waiting for manual reports from different people.',
  },
  {
    name: 'Rafael Torres',
    role: 'General Manager, Torres Trading',
    rating: 5,
    quote: 'The system made it easier to review transactions branch by branch and prepare cleaner records for audit checks.',
  },
];

const Login =() =>{
  const { openVideoModal } = useOutletContext();

  useEffect(() => {
    Promise.all([
      import('../dashboard/dashboard.route'),
      import('../dashboard/dashboardBookeeping.route'),
    ]).catch(() => {});
  }, []);

  useEffect(() => {
    const appId = (process.env.REACT_APP_FACEBOOK_APP_ID ?? '').trim();
    if (!appId) {
      setFacebookReady(false);
      return;
    }
    if (window.FB) {
      setFacebookReady(true);
      return;
    }

    if (!document.getElementById('fb-root')) {
      const fbRoot = document.createElement('div');
      fbRoot.id = 'fb-root';
      document.body.appendChild(fbRoot);
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        cookie: true,
        xfbml: false,
        version: 'v20.0',
      });
      setFacebookReady(true);
    };

    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.onerror = () => {
        setFacebookReady(false);
        setFacebookError('Failed to load Facebook. Please try again.');
      };
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    const clientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '').trim();
    if (!clientId) {
      setGoogleReady(false);
      return;
    }
    if (window.google?.accounts?.id) {
      setGoogleReady(true);
      return;
    }

    if (!document.getElementById('google-gsi')) {
      const script = document.createElement('script');
      script.id = 'google-gsi';
      script.async = true;
      script.defer = true;
      script.src = 'https://accounts.google.com/gsi/client';
      script.onload = () => setGoogleReady(true);
      script.onerror = () => {
        setGoogleReady(false);
        setGoogleError('Failed to load Google. Please try again.');
      };
      document.body.appendChild(script);
    }
  }, []);

  const [isErrorLogin, setErrorlogin] = useState(false);

  const [isErrorNotActivated, setErrorNotActivated] = useState(false);
  
  const [isLoading, setLoading] = useState(false);
  const [isFacebookReady, setFacebookReady] = useState(false);
  const [isFacebookLoading, setFacebookLoading] = useState(false);
  const [facebookError, setFacebookError] = useState('');
  const [isGoogleReady, setGoogleReady] = useState(false);
  const [isGoogleLoading, setGoogleLoading] = useState(false);
  const [googleError, setGoogleError] = useState('');
  const [googleButtonRendered, setGoogleButtonRendered] = useState(false);

  const defaultFormFields = {
    email: '',
    password: '',
  };
  const [formFields,setFormFields ] = useState(defaultFormFields);
  const { email, password } = formFields;


  const { Login } = useContext(UserContext);

  const { VersionApp} = useContext(UserContext);

  // const resetFormFields = () => {
  //   setFormFields(defaultFormFields);
  // };

 

  const navigate = useNavigate();



  const postData = {
    "email": email,
    "password": password,
  };

  const fetchData = async () => {
  
    setErrorNotActivated(false);
    setErrorlogin(false);
    try {
     
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const response = await fetch(process.env.REACT_APP_API_URL+'api/login', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': csrfToken, // Include the CSRF token
        },
        body: JSON.stringify(postData)
      })
      console.log(response.status);  

      if(response.status==411 || response.status=='411'){
        setErrorNotActivated(true);
        setLoading(false);
        return;
      }
      if (response.status !== 201) {
        const json = await response.json().catch(() => null);
        if ((json?.message ?? '') === 'Account disabled') {
          setErrorNotActivated(true);
        } else {
          setErrorlogin(true);
        }
       
        setLoading(false);
        return;
      }
      if (response.status === 201) {
        const data = await response.json();
        console.log(data);

        
        handleData(data.token,data.name,data.company_id,data.id,data.is_vat,data.privelege,data.position,data.tax_types,data.trade_name,data.tin,data.reg_address,data.owner_name,data.first_login,data.count_renew,data.is_branch,data.is_fsline_setup);

     
       return;
      } 
      

    } catch (error) {
      console.error(error);
      setLoading(false);
    }


  };

  

  const handleData = (jwt,name,company_id,user_id,is_vat,privelege,position,Tax_types,trade_name,tin,reg_address,owner_name,first_login,count_renew,is_branch,is_fsline_setup) => {

    

    Login(jwt,name,company_id,user_id,is_vat,privelege,position,Tax_types,trade_name,tin,reg_address,owner_name,first_login,count_renew,is_branch,is_fsline_setup);

    if (Number(first_login) === 1) {
      navigate('/change/password');
      return;
    }

    if (position === 'Bookkeeper_') {
      navigate('/company/setup');
      return;
    }

    if (Number(is_fsline_setup) === 0) {
      navigate('/setup/fsline');
      return;
    }

    navigate('/dashboard');
  };

  const handleSubmit =  (event) => {
  
    event.preventDefault();
    setLoading(true);
    fetchData();
   // setLoading(false);
   

    //resetFormFields();
  };


  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  const loginWithGoogleIdToken = async (idToken) => {
    setGoogleError('');
    setErrorNotActivated(false);
    setErrorlogin(false);
    setGoogleLoading(true);
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      const response = await fetch(process.env.REACT_APP_API_URL + 'api/login/google', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {}),
        },
        body: JSON.stringify({ id_token: idToken }),
      });

      if (response.status == 411 || response.status == '411') {
        setErrorNotActivated(true);
        setGoogleLoading(false);
        return;
      }

      if (!response.ok) {
        const json = await response.json().catch(() => null);
        if ((json?.message ?? '') === 'Account disabled') {
          setErrorNotActivated(true);
          setGoogleLoading(false);
          return;
        }
        setGoogleError(json?.message ?? 'Google login failed. Please try again.');
        setGoogleLoading(false);
        return;
      }

      const data = await response.json().catch(() => null);
      if (!data?.token) {
        setGoogleError('Google login failed. Please try again.');
        setGoogleLoading(false);
        return;
      }

      handleData(
        data.token,
        data.name,
        data.company_id,
        data.id,
        data.is_vat,
        data.privelege,
        data.position,
        data.tax_types,
        data.trade_name,
        data.tin,
        data.reg_address,
        data.owner_name,
        data.first_login,
        data.count_renew,
        data.is_branch,
        data.is_fsline_setup
      );
    } catch (error) {
      setGoogleError('Google login failed. Please try again.');
    } finally {
      setGoogleLoading(false);
    }
  };

  useEffect(() => {
    const clientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '').trim();
    if (!isGoogleReady || !clientId || googleButtonRendered) return;
    const container = document.getElementById('google-signin-btn');
    if (!container || !window.google?.accounts?.id) return;

    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: (response) => {
        const token = response?.credential;
        if (!token) {
          setGoogleError('Google login failed. Please try again.');
          return;
        }
        loginWithGoogleIdToken(token);
      },
    });

    container.innerHTML = '';
    window.google.accounts.id.renderButton(container, {
      theme: 'outline',
      size: 'large',
      shape: 'rectangular',
      width: Math.max(280, Math.min(520, container.clientWidth || 360)),
      text: 'signin_with',
    });
    setGoogleButtonRendered(true);
  }, [isGoogleReady, googleButtonRendered]);

  const getFacebookAccessToken = () => {
    return new Promise((resolve, reject) => {
      if (!window.FB) {
        reject(new Error('Facebook SDK not available'));
        return;
      }
      window.FB.login(
        (response) => {
          const token = response?.authResponse?.accessToken;
          if (!token) {
            reject(new Error('Facebook login was cancelled'));
            return;
          }
          resolve(token);
        },
        { scope: 'public_profile,email' }
      );
    });
  };

  const authenticateFacebook = async () => {
    setFacebookError('');
    setErrorNotActivated(false);
    setErrorlogin(false);
    setFacebookLoading(true);
    try {
      if (!isFacebookReady) {
        setFacebookError('Facebook login is not configured.');
        setFacebookLoading(false);
        return;
      }

      const accessToken = await getFacebookAccessToken();
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      const response = await fetch(process.env.REACT_APP_API_URL + 'api/login/facebook', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {}),
        },
        body: JSON.stringify({ access_token: accessToken }),
      });

      if (response.status == 411 || response.status == '411') {
        setErrorNotActivated(true);
        setFacebookLoading(false);
        return;
      }

      if (!response.ok) {
        const json = await response.json().catch(() => null);
        if ((json?.message ?? '') === 'Account disabled') {
          setErrorNotActivated(true);
          setFacebookLoading(false);
          return;
        }
        setFacebookError(json?.message ?? 'Facebook login failed. Please try again.');
        setFacebookLoading(false);
        return;
      }

      const data = await response.json().catch(() => null);
      if (!data?.token) {
        setFacebookError('Facebook login failed. Please try again.');
        setFacebookLoading(false);
        return;
      }

      handleData(
        data.token,
        data.name,
        data.company_id,
        data.id,
        data.is_vat,
        data.privelege,
        data.position,
        data.tax_types,
        data.trade_name,
        data.tin,
        data.reg_address,
        data.owner_name,
        data.first_login,
        data.count_renew,
        data.is_branch,
        data.is_fsline_setup
      );
    } catch (error) {
      setFacebookError('Facebook login failed. Please try again.');
    } finally {
      setFacebookLoading(false);
    }
  };

    return (
      <>
        <div className="flex min-h-full flex-1 ">
          <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div className="mx-auto w-full max-w-sm lg:w-96">
              <div>
              <img
                  className="w-32 mx-auto  "
                  src={process.env.PUBLIC_URL + '/logoIcon.png'} 
                  alt="Your Company"
                />
    
                  <div className="mt-8 text-center">
          

                  <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900 !normal-case">
                    Sign in to your account
                  </h2>

                  <p className="mt-2 text-sm leading-6 text-gray-500">
                    Not a member?{' '}
                    <a
                      href="/step"
                      className="font-semibold text-blue-600 hover:text-blue-500"
                    >
                      Start Your 30-Day Free Trial
                    </a>
                  </p>

                  <p className="mt-2 text-sm leading-6 text-gray-500">
                    Be a Bookkeeper?{' '}
                    <a
                      href="/register/bookeeper"
                      className="font-semibold text-blue-600 hover:text-blue-500"
                    >
                      Sign Up
                    </a>
                  </p>
                  <div className="mt-5 flex items-center justify-center">
                    <button
                      type="button"
                      onClick={openVideoModal}
                      className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-5 py-2.5 text-sm font-semibold text-blue-700 shadow-sm transition hover:bg-blue-100"
                    >
                      Watch Pentabooks Demo
                    </button>
                  </div>
                </div>
              </div>
  
              <div className="mt-10">
                <div>
                  <form onSubmit={handleSubmit} method="POST" className="space-y-6">
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900  !normal-case">
                        Email Address or Username
                      </label>
                      <div className="mt-2">
                        <input
                          id="email"
                          name="email"
                          type="email"
                          // value={email}
                          onChange={handleChange}
                          required
                          className="p-2.5 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
  
                    <div>
                      <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                        Password
                      </label>
                      <div className="mt-2">
                        <input
                          id="password"
                          name="password"
                          type="password"
                          value={password}
                          onChange={handleChange}
                          required
                          className="p-2.5 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
  
          
                    <div>
       
                      {isLoading? 
                        <button disabled type="button" class="uppercase flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
                          <svg aria-hidden="true" role="status" class="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                          </svg>
                          Connecting...
                        </button>
                      
                      :
                      <button
                      type="submit"
                      className="uppercase flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 !normal-case"
                    >
                      Sign in
                    </button>}

                    </div>
                     
                  </form>
                  <div className="mt-4 grid grid-cols-1 gap-3">
                    <div id="google-signin-btn" className="w-full" />
                    {isGoogleLoading ? (
                      <p className="text-center text-sm text-gray-500">Connecting Google...</p>
                    ) : null}
                    {googleError ? (
                      <div class="rounded-md bg-red-50 p-4">
                        <div class="flex">
                          <div class="flex-shrink-0">
                            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                            </svg>
                          </div>
                          <div class="ml-3">
                            <div class="mt-2 text-sm text-red-700">
                              <ul role="list" class="list-disc space-y-1 pl-5">
                                <li>{googleError}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <button
                      type="button"
                      disabled={isFacebookLoading || !isFacebookReady}
                      onClick={authenticateFacebook}
                      className="flex w-full items-center justify-center gap-2 rounded-md border border-[#1877F2] bg-white px-3 py-2 text-sm font-semibold leading-6 text-[#1877F2] shadow-sm hover:bg-blue-50 disabled:opacity-60"
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        className="h-5 w-5 fill-current"
                      >
                        <path d="M13.5 22v-8h2.8l.5-3H13.5V9.1c0-.9.3-1.6 1.7-1.6H17V4.8c-.3 0-1.4-.1-2.8-.1-2.7 0-4.6 1.6-4.6 4.6V11H7v3h2.6v8h3.9Z" />
                      </svg>
                      {isFacebookLoading ? 'Connecting Facebook...' : 'Login with Facebook'}
                    </button>
                  </div>
                  {facebookError ? (
                    <div class="rounded-md bg-red-50 p-4 mt-4">
                      <div class="flex">
                        <div class="flex-shrink-0">
                          <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                          </svg>
                        </div>
                        <div class="ml-3">
                          <div class="mt-2 text-sm text-red-700">
                            <ul role="list" class="list-disc space-y-1 pl-5">
                              <li>{facebookError}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {isErrorLogin?
                   <div class="rounded-md bg-red-50 p-4 mt-4">
                        <div class="flex">
                            <div class="flex-shrink-0">
                            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                            </svg>
                            </div>
                            <div class="ml-3">
                            <div class="mt-2 text-sm text-red-700">
                                <ul role="list" class="list-disc space-y-1 pl-5 uppercase">
                                {/* <li>Your password must be at least 8 characters</li> */}
                                <li>Invalid Username and password</li>
                                </ul>
                            </div>
                            </div>
                        </div>
                    </div>
                  :''
                  }  
                {/* <div className="flex gap-x-6 mt-12">
                      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-indigo-600">
                        <ChatBubbleLeftRightIcon aria-hidden="true" className="size-6 text-white" />
                      </div>
                      <div>
                        <h3 className="text-base/7 font-semibold text-gray-900">Help Support</h3>
                        <p className="mt-2 text-base/7 text-gray-600">
                        Please contact us on our Facebook page for any concerns.
                        </p>
                        <p className="mt-4 text-sm/6 font-semibold">
                          <a href="https://www.facebook.com/profile.php?id=61567139582506" target='blank' className="text-indigo-600">
                            Contact us <span aria-hidden="true">&rarr;</span>
                          </a>
                        </p>
                      </div>
                    </div> */}
                  {isErrorNotActivated?
                  <div class="rounded-md bg-red-50 p-4 mt-4">
                        <div class="flex">
                            <div class="flex-shrink-0">
                            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                            </svg>
                            </div>
                            <div class="ml-3">
                            <div class="mt-2 text-sm text-red-700">
                                <ul role="list" class="list-disc space-y-1 pl-5 uppercase">
                                {/* <li>Your password must be at least 8 characters</li> */}
                                <li>Please activate your account. Call administrator.</li>
                                </ul>
                            </div>
                            </div>
                        </div>
                    </div>
                       :''
                      }  
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center h-screen hidden sm:block">
          <div class="flex items-center justify-center h-full relative ">
          <img
              className="h-full w-full object-fill	"
              src={`${process.env.PUBLIC_URL}/PENTABOOKS COVER.png`} 
              alt="Example Image"
            />
              <div className="overlay absolute inset-0  px-24 pt-10 items-center justify-center flex">
                <div className='bg-black flex bg-opacity-50 gap-4'>
                {/* <div className='w-6/12 border-white border-2 px-2'>
                    <span className="text-white text-2xl font-bold underline">Pentabooks</span>
                    <p className='text-white px-2'>
                    Our company is dedicated to transforming financial management through innovative digital bookkeeping solutions. We are committed to driving the digitalization of local businesses, enabling them to achieve seamless efficiency and growth.
                    </p>
                    </div>
                    <div className='w-6/12 border-white border-2'>
                       <span className="text-white text-2xl font-bold underline px-2">Our Mission</span>
                       <p className='text-white px-2'>
                       Transforming financial management with innovative digital bookkeeping for seamless digitalization, efficiency, and growth.
                       </p>
                    </div> */}
                </div>
             
              </div>
             </div>
          </div>
        </div>
        <section id="customer-reviews" className="bg-slate-50 px-4 py-14 sm:px-6 lg:px-20">
          <div className="mx-auto max-w-7xl">
            <div className="flex items-start justify-between gap-4 flex-col md:flex-row md:items-end">
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">Customer Reviews</p>
                <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">
                  Trusted by growing businesses and bookkeepers
                </h2>
                <p className="mt-3 max-w-2xl text-sm text-slate-600 sm:text-base">
                  Feedback from businesses using Pentabooks for day-to-day bookkeeping, expense tracking, and month-end reporting.
                </p>
              </div>
              <div className="rounded-2xl border border-blue-100 bg-white px-4 py-3 shadow-sm">
                <p className="text-sm font-semibold text-slate-900">4.9 average rating</p>
                <p className="text-xs text-slate-500">Based on 10 recent customer reviews</p>
              </div>
            </div>

            <div className="mt-8 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
              {customerReviews.map((review) => (
                <article
                  key={`${review.name}-${review.role}`}
                  className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
                >
                  <div className="flex items-center justify-between gap-4">
                    <div>
                      <p className="text-base font-semibold text-slate-900">{review.name}</p>
                      <p className="text-sm text-slate-500">{review.role}</p>
                    </div>
                    <div className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
                      {'★'.repeat(review.rating)}
                    </div>
                  </div>
                  <p className="mt-4 text-sm leading-6 text-slate-600">"{review.quote}"</p>
                </article>
              ))}
            </div>
          </div>
        </section>
          <Footer />
      </>
     
    )
  }
  export default Login;
